// extracted by mini-css-extract-plugin
export default {"c":"style_c__wau1a"};